/*
  pl-carrinho-gaveta (20/10/2026): o que a gaveta nova do carrinho precisa de JavaScript. Só carrega com a chave
  "Gaveta do carrinho" ligada nos ajustes do tema (sections/cart-drawer.liquid).

  Pedido do Diogo: a gaveta estava apertada por causa das sugestões — no celular elas ficavam entre os itens e o
  resumo e empurravam o "Finalizar Compra" para a beira da tela; no computador viravam uma coluna à esquerda.

  1. SUGESTÕES SEMPRE DENTRO DA GAVETA. O <cart-related> do pacote do tema (assets/main-*.js, que não pode ser
     reconstruído — OPERACAO.md, "Risco estrutural") se muda sozinho para fora da gaveta no computador, em
     setupLayout(), e repete isso a cada resize. Em vez de mexer no pacote, troca-se só esse método na classe já
     registrada: a sugestão vira o último filho da gaveta, e o CSS a põe depois do resumo.

  2. RODAPÉ FIXO COM AS DUAS FORMAS DE PAGAR. O total no Pix é COPIADO do resumo (o tema o calcula e o mantém em
     dia; dois cálculos dariam centavo diferente na mesma tela). O parcelado sai do subtotal, que é o preço no
     cartão, com a regra do próprio tema (calculateCheckoutInstallments): parcelas = mínimo entre o máximo da loja
     e subtotal ÷ parcela mínima; 1 parcela = "ou R$ X no cartão".
     Não se usa a linha de parcelas do resumo: ela é calculada sobre o total do carrinho, que já vem com o desconto
     do Pix quando o cupom AVISTAOFF está aplicado.
*/
(function () {
  'use strict';
  if (window.__plCarrinhoGaveta) return;
  window.__plCarrinhoGaveta = true;

  // ---------- 1. sugestões dentro da gaveta ----------
  function dentroDaGaveta(el) {
    var gaveta = el.closest('.cart-drawer-wrapper');
    if (!gaveta) return;
    var carrinho = gaveta.querySelector('cart-component');
    if (carrinho && el.parentElement !== carrinho) carrinho.appendChild(el);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-related').then(function () {
      var Classe = customElements.get('cart-related');
      if (!Classe || Classe.prototype.__plDentro) return;
      Classe.prototype.__plDentro = true;
      Classe.prototype.setupLayout = function () {
        dentroDaGaveta(this);
      };
      document.querySelectorAll('.pl-gaveta-nova cart-related').forEach(dentroDaGaveta);
    });
  }

  // ---------- 2. rodapé com o total no Pix e o parcelado ----------
  var BRL = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2});

  // "R$ 1.234,56" -> 1234.56; texto sem número -> NaN
  function reais(texto) {
    var limpo = String(texto || '').replace(/[^\d,]/g, '').replace(',', '.');
    return limpo ? parseFloat(limpo) : NaN;
  }

  function trocar(el, html) {
    if (el && el.innerHTML !== html) el.innerHTML = html;
  }

  function atualizar(gaveta) {
    var totais = gaveta.querySelector('[data-pl-rodape-totais]');
    if (!totais) return;

    var pix = gaveta.querySelector('.cart-checkout__pix-value');
    var valorPix = pix && pix.textContent.trim();
    if (valorPix) trocar(totais.querySelector('[data-pl-rodape-pix]'), valorPix);

    var total = gaveta.querySelector('[data-cart-value="total"]');
    if (total && total.textContent.trim()) trocar(totais.querySelector('[data-pl-rodape-total]'), total.textContent.trim());

    var cartao = totais.querySelector('[data-pl-rodape-cartao]');
    var sub = gaveta.querySelector('[data-cart-value="subtotal"]') || total;
    var valor = sub ? reais(sub.textContent) : NaN;
    if (!cartao || !(valor > 0)) return;
    // Com o frete calculado, o total no Pix do tema já soma o frete (frete-regional.js); o cartão soma também,
    // senão a mesma tela mostraria "R$ 66,27 no Pix" e "2x de R$ 30,97" sem o frete (visto pelo Diogo em 20/10).
    // "Grátis" ou "Informe seu CEP" não viram número e não somam nada.
    var frete = gaveta.querySelector('[data-shipping-estimate-value]');
    var valorFrete = frete ? reais(frete.textContent) : NaN;
    if (valorFrete > 0) valor += valorFrete;

    var maximo = parseInt(totais.getAttribute('data-parcelas'), 10) || 1;
    var minimo = parseFloat(totais.getAttribute('data-parcela-min')) || 0;
    var parcelas = minimo > 0 ? Math.min(Math.floor(valor / minimo), maximo) : maximo;
    if (parcelas > 1) {
      var semJuros = totais.getAttribute('data-sem-juros') === 'true' ? ' sem juros' : '';
      trocar(cartao, 'ou em até <b>' + parcelas + 'x de ' + BRL.format(valor / parcelas) + '</b>' + semJuros + ' no cartão');
    } else {
      trocar(cartao, 'ou <b>' + BRL.format(valor) + '</b> no cartão');
    }
  }

  function vigiar(gaveta) {
    if (gaveta.__plVigia) return;
    gaveta.__plVigia = true;
    var agendado = false;
    var observador = new MutationObserver(function () {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () {
        agendado = false;
        atualizar(gaveta);
      });
    });
    observador.observe(gaveta, {childList: true, subtree: true, characterData: true});
    atualizar(gaveta);
  }

  function iniciar() {
    document.querySelectorAll('drawer-component.pl-gaveta-nova').forEach(vigiar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
